import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    render({ product }) {
        const url = product.product_url.replace(/^https:\/\/www\.tarot\.com/, '');
        const label = product.product_name;

        return (
            <catalog-product>
                <a
                  onClick={() => this.trackClick(label)}
                  href={url}
                >
                    <img alt={product.product_name} src={product.catalog_image} class='product-image' />
                    {this.renderPrice(product)}
                    <h3>
                        <span>{product.product_name}</span>
                    </h3>
                </a>
            </catalog-product>
        );
    }

    renderPrice(product) {
        if (product.on_sale !== null) {
            let price = 'FREE';

            const special_products_price_map = {
                'karma-coin-package': 'SELECT PACKAGE',
            };

            if (product.code in special_products_price_map) {
                price = special_products_price_map[product.code];
            } else if (product.kc) {
                price = product.kc + ' KARMA COINS';
            }

            return (
                <p>
                    <img
                      alt='Karma Coins'
                      src='https://gfx.tarot.com/images/site/tarot/karma-coin-store/coin.svg'
                    />
                    {price}
                </p>
            );
        }

        return (<p>&nbsp;</p>);
    }

    trackClick = (label) => {
        const action = this.props.logged_in ? 'LI Click' : 'LO Click';

        this.props.trackEvent(['Catalog', action, label]);
        this.props.trackPromo(['Catalog', label]);
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: payload => dispatch({ type: 'ga:event', payload: payload }),
    trackPromo: data => dispatch({ type: 'promo-tracker:recordInternal', payload: data }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/catalog/product.js